import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { Progress } from '../models/progress.model';

const PROGRESS_CACHE_TTL_MS = 1000;

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  /** Short-lived cache so bursts of calls for the same course/member within 1s share one request. */
  private progressCache = new Map<string, { promise: Promise<Progress[]>; timestamp: number }>();

  constructor(private http: HttpClient) { }

  async getProgressByCourse(courseId: number, memberId: number): Promise<Progress[]> {
    const key = `${courseId}:${memberId}`;
    const cached = this.progressCache.get(key);
    if (cached && Date.now() - cached.timestamp < PROGRESS_CACHE_TTL_MS) {
      return cached.promise;
    }

    const promise = lastValueFrom(this.http.get<Progress[]>(`${environment.apiUrl}/courses/${courseId}/regmembers/${memberId}/progress`));
    this.progressCache.set(key, { promise, timestamp: Date.now() });
    // Don't cache a failed request - let the next call retry immediately.
    promise.catch(() => this.progressCache.delete(key));
    return promise;
  }

  async memberProgressByCourse(courseId: number, memberId: number, quizSubmission: any, params?: any): Promise<any> {
    this.progressCache.delete(`${courseId}:${memberId}`);
    return await lastValueFrom(this.http.post<Progress>(`${environment.apiUrl}/courses/${courseId}/regmembers/${memberId}/progress`, quizSubmission, {
      params
    }));
  }

  async deleteProgress(courseId: number, memberId: number, progressId: number): Promise<any> {
    this.progressCache.delete(`${courseId}:${memberId}`);
    return await lastValueFrom(this.http.delete(`${environment.apiUrl}/courses/${courseId}/regmembers/${memberId}/progress/${progressId}`));
  }
}
